import locationReducer from './reducers';

export const { initLocation } = locationReducer.actions;
